import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './ui';
import { number } from './positionRollup';
import { completeSum, maturityEvents } from './portfolioDashboardData';
import { dealReportPath } from './links';
import { day, money as formatMoney } from './format';

// One money style across the app (usability review, item 6): whole dollars,
// negatives in brackets; a figure that did not load says so in words.
const money = value => number(value) === null ? 'Unavailable' : formatMoney(value, { whole: true });
export function PortfolioChanges({reports, loading}) {
  const rows = [
    ['Posted income', completeSum(reports.map(r => r?.income?.total?.mtd?.usd))],
    ['Posted expenses', completeSum(reports.map(r => r?.expenses?.total?.mtd?.usd))],
    ['Net posted result', completeSum(reports.map(r => r?.net_income?.mtd?.usd))],
  ];
  return <Card title="Portfolio changes · month to date"><div className="portfolio-detail">
    {loading ? <p>Loading fund income statement…</p> : rows.map(([label,value]) => <div className="portfolio-line" key={label}><span>{label}</span><strong>{money(value)}</strong></div>)}
    <p className="portfolio-note">Fund books only · posted income less expenses; investor contributions are excluded. Unposted valuation and currency movements are not included.</p>
    {reports.length > 0 && <p className="portfolio-note">Books: {reports.map(r => r.bookName).join(', ')} · through {reports[0]?.as_of}</p>}
  </div></Card>;
}
export function UpcomingCashEvents({data}) {
  const events = maturityEvents(data);
  return <Card title="Upcoming cash events · next 90 days"><div className="portfolio-detail">
    {!data ? <p>Cash event data unavailable.</p> : !events.length ? <p>No note maturities recorded in the next 90 days.</p> : events.map((e,i) => <div className="portfolio-event" key={i}><time>{day(e.date)}</time><div><strong>{e.deal_id ? <Link to={dealReportPath(e.deal_id)}>{e.name}</Link> : e.name}</strong><small>Contractual note maturity · principal</small></div><strong>{formatMoney(e.amount, { currency: e.currency })}</strong></div>)}
    <p className="portfolio-note">Scheduled principal is shown in its original currency, not available cash. Repayment timing requires confirmation. Coupon schedules and unfunded deal commitments are not yet available in this view.</p>
  </div></Card>;
}
